import CONSTANTS from '../services/constants/constantStrings'
import store from '@/store'

const isStorageAvailable = (type) => {
  try {
    const testKey = '__test__'
    window[type].setItem(testKey, testKey)
    window[type].removeItem(testKey)
    return true
  } catch {
    return false
  }
}

const useIncognitoFallback = {
  local: !isStorageAvailable('localStorage'),
  session: !isStorageAvailable('sessionStorage')
}

const Storage = {
  getLocalStorageData(key, usePrefix = true) {
    if (usePrefix) key = CONSTANTS.KEY_PREFIX + key
    try {
      if (useIncognitoFallback.local) {
        return store.state.incognitoModeData.localStorage[key]
      }
      const stringifiedValue = localStorage.getItem(key)
      try {
        return JSON.parse(stringifiedValue)
      } catch {
        // value is not JSON parsable
        return stringifiedValue
      }
    } catch (e) {
      console.log('Local Storage error', e)
    }
  },

  setLocalStorageData(key, value, usePrefix = true) {
    if (usePrefix) key = CONSTANTS.KEY_PREFIX + key
    try {
      if (useIncognitoFallback.local) {
        store.state.incognitoModeData.localStorage[key] = value
        return
      }
      let stringifiedValue = JSON.stringify(value)
      localStorage.setItem(key, stringifiedValue)
    } catch (e) {
      console.log('Local Storage error', e)
    }
  },

  removeLocalStorageData(key, usePrefix = true) {
    if (usePrefix) key = CONSTANTS.KEY_PREFIX + key
    try {
      if (useIncognitoFallback.local) {
        delete store.state.incognitoModeData.localStorage[key]
        return
      }
      localStorage.removeItem(key)
    } catch (e) {
      console.log('Local Storage error', e)
    }
  },

  setSessionStorageData(key, value, usePrefix = true) {
    if (usePrefix) key = CONSTANTS.KEY_PREFIX + key
    try {
      if (useIncognitoFallback.session) {
        store.state.incognitoModeData.sessionStorage[key] = value
        return
      }
      let stringifiedValue = JSON.stringify(value)
      sessionStorage.setItem(key, stringifiedValue)
    } catch (e) {
      console.log('Session Storage error', e)
    }
  },

  removeSessionStorageData(key, usePrefix = true) {
    if (usePrefix) key = CONSTANTS.KEY_PREFIX + key
    try {
      if (useIncognitoFallback.session) {
        delete store.state.incognitoModeData.sessionStorage[key]
        return
      }
      sessionStorage.removeItem(key)
    } catch (e) {
      console.log('Session Storage error', e)
    }
  },

  getSessionStorageData(key, usePrefix = true) {
    if (usePrefix) key = CONSTANTS.KEY_PREFIX + key
    try {
      if (useIncognitoFallback.session) {
        return store.state.incognitoModeData.sessionStorage[key]
      }

      const stringifiedValue = sessionStorage.getItem(key)
      try {
        return JSON.parse(stringifiedValue)
      } catch {
        // value is not JSON parsable
        return stringifiedValue
      }
    } catch (e) {
      console.log('Session Storage error', e)
    }
  }
}

export default Storage
